import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { States, MerchantBannerConfig, MerchantConfig } from 'app/application/application';
import { AwsTrackingService } from 'app/common/tracking/aws-tracking.service';
import { ApplicationService } from 'app/application/application.service';
import { PersonalDetailsService } from 'app/customer/personal-details/personal-details.service';
import { TokenService } from 'app/token/token.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { PersonalLoanPricingCap } from 'app/cash-credit/cash-credit/cash-credit';
import { LoaderService, Loader } from 'app/common/loader/loader.service';
import { PostAccept } from 'app/risk/risk';
import { DeviceDetectService } from 'app/common/device-detect/device-detect.service';
import { EventDetails } from './../../common/tracking/aws-tracker';
import { MerchantSetting } from '../../landing-pages/gift-card/gift-card';

declare let $;

@Component({
  selector: 'zest-merchants-card',
  templateUrl: './merchants-card.component.html',
  styleUrls: ['./merchants-card.component.scss']
})
export class MerchantsCardComponent implements OnInit, OnDestroy {

  @Input() states: States;
  @Input() clState: PostAccept;
  @Input() merchantConfig: MerchantConfig;

  @Output() showAllModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  merchantRedirectUrl: string;
  allMerchantBannerConfig: MerchantBannerConfig[];
  showAllMerchants: boolean;
  merchantName: string;
  cashCreditMerchantName: string;
  merchantKey: string;
  merchantBannerConfig: MerchantBannerConfig;
  customIcon: boolean;
  cashCreditPricing: PersonalLoanPricingCap;
  isDesktop: boolean;
  creditLimitAmount: Number;
  s3Url = environment.s3BucketUrl;
  isETMoney: boolean;
  displayMerchantList: MerchantBannerConfig[];
  kycDone: boolean;
  merchantSettings: MerchantSetting[];
  public googlepayFlowEnabled = false;

  constructor(
    private awsTrackingService: AwsTrackingService,
    private applicationService: ApplicationService,
    private personalDetailsService: PersonalDetailsService,
    private tokenService: TokenService,
    private loaderService: LoaderService,
    private deviceService: DeviceDetectService,
    private router: Router
  ) { }

  ngOnInit() {
    this.googlepayFlowEnabled = this.tokenService.getGooglePayEnableFlag();
    const kycSkip = this.tokenService.getKycSkip();
    if (kycSkip && kycSkip.skip) {
      this.kycDone = this.states.customer.kycFlowCompleted;
    } else {
      this.kycDone = this.states.customer.proofOfIdUploaded || this.states.customer.kycFlowCompleted;
    }
    this.isETMoney = this.tokenService.getCustomMerchantConfig();
    this.isDesktop = this.deviceService.isDesktop();
    this.merchantSettings = this.tokenService.getMerchantSettings();
    this.merchantKey = this.getMerchantKey(this.merchantConfig.merchantId);
    this.merchantRedirectUrl = this.tokenService.getMerchantCustomerRedirectUrl();

    if (this.clState && this.clState.credit_limit) {
      // Show the cash credit slider if it's a cash credit customer or else show banner
      if (this.merchantConfig.cashCreditEnabled && this.kycDone) {
        this.checkForCashCredit(0);
      } else {
        this.createMerchantRedirectUrl();
        this.configureBanner();
      }
    } else {
      this.createMerchantRedirectUrl();
      this.configureBanner();
    }
  }

  createUrl(url: string) {
    if (url && url.substring(0, 4) !== 'http') {
      url = 'http://' + url;
    }
    return url;
  }

  createMerchantRedirectUrl() {
    if (this.merchantRedirectUrl) {
      this.merchantRedirectUrl = this.createUrl(this.merchantRedirectUrl);
    } else {
      this.personalDetailsService.getPersonalDetailsV2().subscribe(response => {
        this.merchantRedirectUrl = response.MerchantCustomerResponse ? response.MerchantCustomerResponse.RedirectUrl : null;
        if (this.merchantRedirectUrl) {
          this.tokenService.setMerchantCustomerRedirectUrl(this.merchantRedirectUrl);
          this.merchantRedirectUrl = this.createUrl(this.merchantRedirectUrl);
        }
      });
    }
  }

  configureBanner() {
    const currentMerchantId = this.merchantConfig.merchantId;
    // Fetch Merchant banner config json
    this.applicationService.getMerchantBannerConfig().subscribe((config) => {
      this.allMerchantBannerConfig = config.merchantBannerList;

      // Check which merchant banner to display
      if ((currentMerchantId && currentMerchantId === environment.zestMerchantId) || this.googlepayFlowEnabled) {
        this.showAllMerchants = true;
        this.displayMerchantList = this.allMerchantBannerConfig.filter((merchant, index) => {
          if (index < 6 && (merchant.genericBanner || (merchant.bannerList && merchant.bannerList.length))) {
            return true;
          }
        });
      } else if (this.merchantConfig.merchantName) {
        this.merchantName = this.merchantConfig.merchantName;
      } else {
        this.applicationService.getMerchantName(currentMerchantId).subscribe((merchantName) => {
          this.merchantName = merchantName;
          this.merchantBannerConfig = this.allMerchantBannerConfig.find(config => config.merchantName.toLowerCase() === merchantName.toLowerCase());
        },
          (error) => {
            this.showCustomIcon();
          });
      }
    });
  }

  getMerchantKey(merchantId) {
    const merchantSetting = this.merchantSettings ? this.merchantSettings.find(merchant => merchant.merchantId === merchantId) : null;
    return merchantSetting ? merchantSetting.partnerName : null;
  }

  showCustomIcon() {
    this.customIcon = true;
  }

  checkForCashCredit(count: number) {
    if (count <= 3) {
      if (this.states.customer.customCreditLimitAllowed) {
        this.applicationService.getPersonalLoanCapPricing().subscribe(pricing => {
          if (pricing) {
            this.cashCreditPricing = pricing;
            this.applicationService.getMerchantName(this.states.customer.customCLMerchantId).subscribe(response => {
              this.cashCreditMerchantName = response;
            });
          }
        });
      } else {
        setTimeout(() => {
          this.applicationService.getState(null).subscribe(states => {
            this.states = states;
            this.checkForCashCredit(count + 1);
          });
        }, (1000 + count * 1000));
      }
    } else {
      this.configureBanner();
    }
  }

  toggleStepsModal(state) {
    if (state === 'open') {
      this.awsTrackingService.gtmTriggerEvent('flipkart-banner-opened');
    }
    $('#howItWorks').modal(state);
  }

  showHowItWorks(merchant, isModal = false) {
    if (!this.googlepayFlowEnabled) {
      if (merchant) {
        if (isModal) {
          this.logEvent('ocd_merchant_modal_' + merchant.merchantName + '_click');
        } else {
          this.logEvent('ocd_banner_' + merchant.merchantName + '_click');
        }
        const selectedMerchantSetting = this.merchantSettings ? this.merchantSettings.filter(merchantSetting => (merchantSetting.partnerName.toLowerCase() === merchant.merchantName.toLowerCase()))[0] : '';
        if (selectedMerchantSetting && selectedMerchantSetting.isActive) {
          // show how it works
          this.merchantName = merchant.merchantName;
          this.toggleStepsModal('open');
        } else {
          // redirect user to merchant website
          if (merchant.url && merchant.url !== '#') {
            window.location.href = merchant.url;
          }
        }
      } else if (this.merchantRedirectUrl) {
        window.location.href = this.merchantRedirectUrl;
      }
    }
  }

  getVoucher(merchantName) {
    const avialableCreditLimit = this.clState ? this.clState.credit_limit.available_amt : 0;
    merchantName = merchantName.toLowerCase();
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.awsTrackingService.gtmTriggerEvent(merchantName + '-get-voucher-clicked');
    const selectedMerchantSetting = this.merchantSettings.filter(merchantSettings => (merchantSettings.partnerName.toLowerCase() === merchantName))[0];
    if (selectedMerchantSetting) {
      const data = {
        tv: merchantName,
        sz: selectedMerchantSetting.merchantId,
        ue: btoa(this.states.customer.customerId),
        ew: Math.min(avialableCreditLimit, selectedMerchantSetting.maxLimit),
        ly: 'Gift Card',
        va: avialableCreditLimit,
        fx: true
      };
      // this.headerService.ShowHeaderSource.next(new Header(0, false, 0, false, '', false));
      this.toggleStepsModal('close');
      this.showAllMerchantsBottomSheet('close');
      setTimeout(() => {
        this.router.navigate(['/emi/get'], { queryParams: data });
      }, 1000);
    }
  }

  showAllMerchantsBottomSheet(state) {
    $('#all-merchants').modal(state);
  }

  logEvent(eventName, eventType = 'event') {
    this.awsTrackingService.gtmPageLoadEvent(eventName);
    const event = new EventDetails(eventName, eventType, 'triggered');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
  }

  showAllMerchantsModal() {
    this.showAllModal.emit(true);
  }

  ngOnDestroy() {
    this.tokenService.removeAllModals();
    $('.modal-overlay').remove();
  }

}
